<template>
  <div class="app-container">
    WELCOME , {{ $store.getters.userInfo.name }}
    <BjDivider>
      <b>User Manual and Video Tutorial</b>
      <template slot="right">
        <el-button @click="tryCancel()">Download User Manual</el-button>
      </template>
    </BjDivider>
    <BjStatusTabs
      :value="queryParamsTradeStatus"
      :option-list="TAB_LIST"
      @handleTabClick="handleTabClick"
    />
    <div class="maxbox">
      <div class="flexBox">
        <div class="textBox">默认</div>
        <div class="videoBox">
          <video controls="controls">
            <source :src="src" />
          </video>
        </div>
      </div>
      <div class="flexBox">
        <div class="textBox">自定义</div>
        <div class="videoBox">
          <video controls="controls" width="100%" height="100%">
            <source :src="src1" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      queryParamsTradeStatus: '1',
      TAB_LIST: [
        {
          label: 'OVERALL',
          value: '1',
        },
        {
          label: 'PRODUCTS',
          value: '2',
        },
        {
          label: 'PURCHASE ORDERS',
          value: '3',
        },
        {
          label: 'ORDERS',
          value: '4',
        },
      ],
      src: 'https://pgcvideo-cdn.xiaodutv.com/2011713909_3510916223_2018031614542020180316153810.mp4?authorization=bce-auth-v1%2Fc308a72e7b874edd9115e4614e1d62f6%2F2018-03-16T07%3A45%3A43Z%2F-1%2F%2F094eb8d123373e1466f63d454b1aeb21a16ef0b35ea5df07b3ddd2b499cf0d47&responseCacheControl=max-age%3D8640000&responseExpires=Sun%2C+24+Jun+2018+15%3A45%3A43+GMTmp4&sign=1715135323-7057641-0-ec962f3836d58cebd8dfa688c98df665&time=1715221723&xcode=b1168cf547a15e15d03e0e9713347c96fc10b570c55aed0f&_=1715137611863',
      src1: 'https://pgcvideo-cdn.xiaodutv.com/1417007541_2193572211_2019071514381120190715150423.mp4?Cache-Control=max-age%3D8640000&responseExpires=Wed%2C+23+Oct+2019+15%3A16%3A48+GMT&xcode=735c409077f11d7e0cb35a6b9f6c451183c2e4093021cbbe&sign=1715135604-7063631-0-001b3f6e60ed68a74f7ebee797d5fc6c&time=1715222004&_=1715138014458',
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    tryCancel() {
      console.log('tryCancel');
    },
    handleTabClick(e) {
      console.log(e);
    },
  },
};
</script>
<style lang="scss" scoped>
.maxbox {
  display: flex;
  justify-content: space-between;
}
.flexBox {
  width: 48%;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.textBox{
    color: #ccc;
    margin-bottom: 5px;
}
.videoBox{
    width: 98%;
    height: 90%;
    video{
        width: 100%;
        height: 100%;
    }
}
</style>
